/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
/* tslint:disable */

// Import CSS to ensure it's bundled
import '../assets/styles/index.css';

import { AppController } from './AppController';
import { preloadMarkdownParser } from '../utils/markdown';

// Preload markdown parser for better performance
preloadMarkdownParser().catch(console.error);

document.addEventListener('DOMContentLoaded', () => {
  new AppController();

  document.querySelectorAll<HTMLElement>('[contenteditable][placeholder]').forEach(el => {
    const placeholder = el.getAttribute('placeholder')!;
    function updatePlaceholderState() {
      const currentText = (el.id === 'polishedNote' || el.id === 'translatedNote' ? el.innerText : el.textContent)?.trim();
      if (currentText === '' || (currentText === placeholder && el.classList.contains('placeholder-active'))) {
        if ((el.id === 'polishedNote' || el.id === 'translatedNote') && el.innerHTML.trim() === '') el.innerHTML = placeholder;
        else if (el.id !== 'polishedNote' && el.id !== 'translatedNote' && el.textContent?.trim() === '') el.textContent = placeholder;
        el.classList.add('placeholder-active');
      } else if (currentText !== placeholder) {
        el.classList.remove('placeholder-active');
      }
    }
    updatePlaceholderState();
    el.addEventListener('focus', function () {
      if (this.innerText.trim() === placeholder && this.classList.contains('placeholder-active')) {
        this.innerHTML = '';
        this.classList.remove('placeholder-active');
      }
    });
    el.addEventListener('blur', () => setTimeout(updatePlaceholderState, 0));
    el.addEventListener('input', function() {
      if (this.innerText.trim() !== '') this.classList.remove('placeholder-active');
    });
  });
});

export {};